<template>
    <div class="addressbook-container">
        <div class="addressbook">
            <div v-if="addressList.length === 0" class="no-address">
                {{ $t('address1') }}
            </div>

            <div v-else class="address-book-items">
                <AddressCard v-for="(address, index) in addressList" :key="index" :address='address' :addressList="addressList.length"></AddressCard>
            </div>

            <v-btn class="addressbook-addnew-btn" v-if="!addNewAddressDialog" v-on:click="addNewAddressDialog = true">
                {{ $t('address2') }}
            </v-btn>
        </div>

        <AddAddressModal :status="addNewAddressDialog" :addAdressButtonLoader="addAdressButtonLoader" :newAddress="newAddress" :country-error="countryError" />
    </div>
</template>

<script>
import AddressCard from './AddressCardNew';
import {mapGetters, mapState} from 'vuex';
import {AUser, ACommon} from '../store/actions';
import {GUser} from '../store/getters';
import {required} from 'vuelidate/lib/validators';
import AddAddressModal from "../components/Modals/AddAddressModal.vue";

export default {
    name: "Addressbook",
    components: {
        AddAddressModal,
        AddressCard
    },
    validations: {
        newAddress: {
            name: {
                required
            },
            firstName: {
                required
            },
            lastName: {
                required
            },
            phoneNumber: {
                required
            },
            street: {
                required
            },
            postCode: {
                required
            },
            city: {
                required
            }
        },
        country: {
            required
        }
    },
    data() {
        return {
            newAddress: {
                name: "",
                type: 3,
                street: "",
                street1: "",
                city: "",
                postCode: "",
                countryId: 4,
                country: "",
                region: "",
                vat: "",
                note: "",
                company: "",
                phoneNumber: "",
                firstName: "",
                lastName: ""
            },
            country: null,
            valid: true,
            addNewAddressDialog: false,
            isDefaultBilling: false,
            isDefaultShipping: false,
            rules: {
                required: value => !!value || 'Required.',
                min: value => !value.length ? true : value.length >= 10 || 'Min 10 characters'
            },
            countryError: false,
            vin_countries: {},
            countryMap: [],
            addAdressButtonLoader: false
        };
    },
    computed: {
        ...mapGetters({
            addressList: GUser.GET_ADDRESSES,
            userData: GUser.GET_USER_DATA
        }),
        ...mapState({
            countries: state => state.countries
        })
    },
    methods: {
        addNewAddress() {
            this.addAdressButtonLoader = true;
            if (this.newAddress.name && this.newAddress.firstName && this.newAddress.lastName && this.newAddress.phoneNumber && this.newAddress.street && this.newAddress.postCode && this.newAddress.city) {
                if (!this.country) {
                    this.countryError = true;
                    return;
                }
                this.countryError = false;

                if (!this.addressList.length) {
                    this.newAddress.type = 3;
                    this.newAddress.isDefault = true;
                } else {
                    this.newAddress.isDefault = false;
                    if (!this.isDefaultBilling && !this.isDefaultShipping) {
                        this.newAddress.type = 4;
                    } else if (this.isDefaultBilling && !this.isDefaultShipping) {
                        this.newAddress.type = 1;
                    } else {
                        this.newAddress.type = 2;
                    }
                }

                this.newAddress.countryId = this.countries[this.country].id;
                this.newAddress.country = this.countries[this.country].value;
                this.$store.dispatch(AUser.ADD_ADDRESS, this.newAddress).then(() => {
                    this.addAdressButtonLoader = false;
                    this.addNewAddressDialog = false;
                    this.$store.dispatch(AUser.GET_ADDRESSES);
                })
            }
        },
        onCloseAddAddressModal() {
            this.addNewAddressDialog = false;
            if (window) {
                document.getElementsByClassName('new-address-dialog')[0].scrollTop = 0;
            }
        },
        getCountries() {
            this.vin_countries = Object.keys(this.countries);
            this.vin_countries.forEach((code) => {
                let allCountries = this.countries,
                    newCountry = {};
                newCountry.id = parseInt(allCountries[code].id);
                newCountry.code = code;
                newCountry.value = allCountries[code].value;
                this.countryMap.push(newCountry);
            })
        }
    },
    created() {
        this.$store.dispatch(AUser.GET_ADDRESSES);
        this.$store.dispatch(ACommon.GET_ALL_COUNTRIES);
        this.getCountries();
        if (this.userData.firstName !== '') {
            this.newAddress.firstName = this.userData.firstName;
        }
        if (this.userData.lastName !== '') {
            this.newAddress.lastName = this.userData.lastName;
        }
        this.$nuxt.$once('onAddAddressGetCountry', (country) => {
            this.country = country
        });
        this.$nuxt.$once('onAddAddress', () => {
            this.addNewAddress()
        });
        this.$nuxt.$once('onCloseAddAddressModal', () => {
            this.onCloseAddAddressModal()
        })
    },
    beforeDestroy() {
        this.$nuxt.$off('onAddAddressGetCountry', (country) => {
            this.country = country
        });
        this.$nuxt.$off('onAddAddress', this.addNewAddress)
        this.$nuxt.$off('onCloseAddAddressModal', () => {
            this.onCloseAddAddressModal()
        })
    }
}
</script>

<style scoped>
h4 {
    margin-bottom: 30px;
}

.no-address {
    margin-bottom: 32px;
}

.myprofile-label {
    font-size: var(--fs-base);
    color: #303030;
    font-weight: 300;
    position: absolute;
    margin-top: -14px;
}

.addressbook-container {
    font-family: 'Roboto', sans-serif;
    font-weight: 400;
    max-width: 1280px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
}

.addresstype-container {
    margin-top: 12px;
    display: none
}

.addresstype-container label {
    font-size: 12px;
}

.v-input--selection-controls {
    margin-top: 0;
}

.addressbook-addnew-btn {
    background: var(--blue) !important;
    color: #FFF !important;
    width: 200px;
    height: 40px !important;
    font-size: 18px;
    border-radius: 5px;
    text-transform: none;
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    letter-spacing: 0;
    font-weight: lighter;
    box-shadow: none;
    margin-bottom: 32px;
}

.v-card__title {
    background: transparent;
    color: #B0B1B0;
}

.v-card__title span {
    font-size: 17px !important;
}

.addaddress-result-img {
    height: 352px;
    width: 352px;
}

.addaddress-fail-text {
    color: red;
    font-size: 1em;
    text-align: center;
    width: 100%;
}

.addaddress-success-text {
    font-size: 1em;
    text-align: center;
    width: 100%;
}

.addressbook-error {
    font-family: 'Roboto', sans-serif;
    font-weight: 400;
    color: #000000;
    margin-bottom: 30px;
    margin-top: 20px;
}

.addressbook-error div {
    font-weight: 700;
    font-size: 21px;
    margin-bottom: 5px;
}

.new-address-left,
.new-address-right {
    display: inline-block;
    width: 50%;
    max-width: 390px;
}

.new-address-left {
    padding: 12px;
}

.new-address-right {
    padding: 12px;
    margin-left: 26px;
}

.new-address-chkbox-wrapper {
    width: 100%;
    padding-left: 12px;
}

.new-address-textarea {
    margin-top: 11px;
}

.new-address-textarea:focus {
    outline: none
}

@media (max-width: 767px) {
    .add-new-address-close {
        right: 15px;
        top: 15px;
    }

    .addressbook-addnew-btn {
        width: 100%;
    }

    .v-dialog.new-address-dialog .theme--light.v-card .v-card__text {
        padding: 16px;
    }

    .addressbook {
        width: 100% !important;
        margin-top: 30px;
    }

    .v-dialog.new-address-dialog .theme--light.v-card {
        padding: 10px !important;
    }

    .v-dialog.new-address-dialog h1 {
        font-size: 20px;
    }

    .v-dialog.new-address-dialog .addnewaddress-btn {
        width: 100%;
        margin-right: 0;
    }

    .v-dialog.new-address-dialog .cancel-btn {
        width: 100%;
        margin-left: 0 !important;
        margin-top: 20px;
        margin-bottom: 20px;
    }

    .v-dialog.new-address-dialog .v-card__actions {
        padding: 8px 12px;
        display: block;
    }
}
</style>
<style>
.new-address-chkbox-wrapper .v-input--checkbox {
    display: inline-block;
}

.new-address-chkbox-wrapper .v-input--checkbox:nth-child(2) {
    margin-left: 30px;
}

.add-new-address-card .mdi-checkbox-blank-outline::before {
    color: #86888F;
}

.new-address-chkbox-wrapper .v-input--checkbox .theme--light.v-messages {
    display: none;
}

.v-input--selection-controls .v-input__control {
    width: 100%;
}

.v-radio {
    flex: auto;
}

.addaddress-result-container .v-responsive.v-image {
    width: 350px;
    height: 350px;
    margin: 0 auto;
}

.address-book-items .addresscard-container {
    display: inline-block;
    width: 410px;
    margin-right: 25px;
    height: 231px;
    vertical-align: top;
}

.address-book-items .addresscard-container:nth-child(3n+0) {
    margin-right: 0;
}

.addressbook-selection {
    width: 35%;
}

.addressbook {
    width: 50%;
}

.icon-label {
    position: relative;
}

.icon-text {
    padding-left: 35px;
    font-size: 18px;
    line-height: 30px;
    color: #707270;
}

.billing-icon {
    width: 28px;
    height: 30px;
    position: absolute;
    background-image: url('../assets/sprite-web.png');
    background-repeat: no-repeat;
    background-position: -128px -53px;
}

.delivery-icon {
    width: 25px;
    height: 25px;
    position: absolute;
    background-image: url('../assets/sprite-web.png');
    background-repeat: no-repeat;
    background-position: -128px -28px;
}

.myprofile-wrapper .myprofile-container .addressbook-container .v-select__selections {
    margin-top: 0;
    padding-left: 0;
    font-weight: 500;
    color: #636463;
    font-size: 18px;
}

.myprofile-wrapper .myprofile-container .addressbook-container .v-text-field .v-input__append-inner {
    top: unset;
    z-index: 7;
}

.addressbook-selection > .flex {
    margin-bottom: 15px;
}

.myprofile-wrapper .addressbook-container .v-input {
    margin: 0;
    padding: 0;
}

.myprofile-wrapper .addressbook-container .v-text-field > .v-input__control > .v-input__slot {
    margin: 0;
}

.addnewaddress-btn.v-btn--disabled {
    color: #FFF !important;
    opacity: 0.5;
}

@media (max-width: 767px) {
    .addressbook {
        width: 100% !important;
        margin-top: 30px;
    }
}
</style>
